import { render } from "./MessageModalComponent.vue?vue&type=template&id=92565d32&scoped=true&ts=true"
import script from "./MessageModalComponent.vue?vue&type=script&lang=ts"
export * from "./MessageModalComponent.vue?vue&type=script&lang=ts"

import "./MessageModalComponent.vue?vue&type=style&index=0&id=92565d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92565d32"]])

export default __exports__